import { useState, useEffect } from 'react'
import { useTheme } from '@/hooks'

type Payload = {
  isDesktop: boolean
  isMobile: boolean
}

const useBreakpoints = (): Payload => {
  const { breakpoints } = useTheme()

  const [isMobile, setIsMobile] = useState<boolean>(
    window.innerWidth <= breakpoints.mobile,
  )

  /* eslint-disable */
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= breakpoints.mobile)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, []) // Empty array ensures that effect is only run on mount and unmount

  return {
    isDesktop: !isMobile,
    isMobile,
  }
}
export default useBreakpoints
